class CustomBundles extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // console.log("connectedCallbackconnectedCallback");
    this.productList = this.querySelector(`[data-product-list]`);
    // console.log("productList",this.productList);
    this.emptyHTML = `<p class="empty-p">No Products selected</p>`;
    this.subtotalEleMain = this.querySelector(`[data-bundle-total-main]`);
    this.discountEleMain = this.querySelector(`[data-bundle-discount-main]`);
    this.subtotalEle = this.querySelector(`[data-bundle-subtotal]`);
    this.discountEle = this.querySelector(`[data-bundle-discount]`);
    this.discountMsgEle = this.querySelector(`[data-bundle-discount-msg]`);
    this.discountAppliedEle = this.querySelector(`[data-bundle-discount-applied]`);
    // this.unlockSound = new Audio('/sounds/unlock.mp3');
    this.totalEle = this.querySelector(`[data-bundle-total]`);
    this.savingsEle = this.querySelector(`[data-bundle-total-savings]`);

    this.discountJSON = JSON.parse(document.querySelector(`[data-discount-json]`).innerHTML);
    // console.log("this.discountJSON",this.discountJSON);
    let a2cBtns = this.querySelectorAll(`[data-bundle-a2c-btn]`);
    // console.log("connectedCallbackconnectedCallback",a2cBtns,this);
    a2cBtns.forEach(btn => {
        btn.addEventListener("click",this.a2cBtnClick.bind(this));
    });
    this.querySelector(`[data-bundle-bulk-add]`).addEventListener("click",this.bundleBulkAdd.bind(this));

    //data-bundle-item-remove
    this.initRemoveBtnClickEvent();
    
    if(document.body.clientWidth <= 989){
      this.initMobileSlider();
    }


  }

  initMobileSlider(){
    $('.bundle-step .grid.allow-slider').slick({
      infinite: false,
      slidesToShow: 1.1,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false
    });
  }

  initRemoveBtnClickEvent(){
    let removeBtns = this.querySelectorAll(`[data-bundle-item-remove]`);
    removeBtns.forEach(btn => {
        btn.addEventListener("click",this.removeBtnClick.bind(this));
    });
  }

  a2cBtnClick(event){
    // console.log("event",event);
    event.preventDefault();
    let btn = event.target;
    let cardProduct = btn.closest(".product-card-wrapper");
    let variantId = cardProduct.querySelector(`variant-radios`) ? cardProduct.querySelector(`variant-radios`).dataset.currentVariant : cardProduct.querySelector(`[data-noscript-variant-radios]`).dataset.currentVariant;
    cardProduct.querySelector(`[data-variants-select] option[value="${variantId}"]`).dataset.added = 'true';
    // btn.dataset.added == 'false' ? btn.dataset.added = "true" : btn.dataset.added = "false";
    this.readyBundleSummary();
  }

  removeBtnClick(event){
    // console.log("event",event);
    event.preventDefault();
    let btn = event.target;
    let bundleItem = btn.closest(".bundle-added-item");
    let option = this.querySelector(`.product-card-wrapper option[data-option-ref="${bundleItem.dataset.optionRef}"]`);
    option.dataset.added = "false";
    option.dataset.qty = 1;
    this.readyBundleSummary();
  }

  readyBundleSummary(){
    // console.log("readyBundleSummary");
    let selectedProducts = this.querySelectorAll(`[data-variants-select] option[data-added="true"]`);
    if(selectedProducts.length > 0){
        let addedProductsItems = ``;
        let subtotal = 0;
        let subtotalCMP = 0;
        selectedProducts.forEach(opt => {
            let cardProduct = opt.closest(".product-card-wrapper");
            let btn = cardProduct.querySelector(`[data-bundle-a2c-btn]`)
            // console.log("cardProduct",cardProduct,btn);
            // let image = cardProduct.querySelector("[data-bundle-image]").src;
            let image = opt.dataset.image;
            let price = opt.dataset.priceFormat;
            let cmpPrice = opt.dataset.cmpPriceFormat;
            let priceReal = parseFloat(opt.dataset.price);
            let priceRealCMP = parseFloat(opt.dataset.cmpPrice);
            subtotal += priceReal*(parseInt(opt.dataset.qty));
            subtotalCMP += priceRealCMP*(parseInt(opt.dataset.qty));
            let variantId = opt.value;
            let variantTitle = cardProduct.querySelector(`variant-radios`) ? cardProduct.querySelector(`variant-radios`).dataset.currentVariant : cardProduct.querySelector(`[data-noscript-variant-radios]`).dataset.currentVariant;
            addedProductsItems += `<div class="bundle-added-item" data-variant-id="${variantId}" data-id="${cardProduct.dataset.id}" data-option-ref="${cardProduct.dataset.id}-${variantId}" data-price="${priceReal}" data-cmp-price="${priceRealCMP}" data-category-index="${btn.dataset.categoryIndex}">
                <div class="bundle-added-item-image"><img src="${image}"></div>
                <div class="bundle-added-item-content">
                    <h5 class="b-title">${btn.dataset.title}</h5>
                    ${opt.textContent != null && opt.textContent != "" ? `<p class="b-price v-title">${opt.textContent}</p>` : ""}
                    <div class="b-price-wrap">
                      <s class="b-price b-cmp-price">${cmpPrice}</s>
                      <p class="b-price">${price}</p>
                    </div>
                    <div class="bundle-quantity">
                    <quantity-input class="quantity cart-quantity bundle-quantity-input">
                      <button class="quantity__button no-js-hidden" name="minus" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></svg>
                      </button>
                      <input
                        class="quantity__input"
                        type="number"
                        value="${opt.dataset.qty}"
                        min="1"
                        step="1"
                        id="Quantity-${variantId}"
                      >
                      <button class="quantity__button no-js-hidden" name="plus" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></svg>
                      </button>
                    </quantity-input>
                    <button class="bundle-item-remove" data-bundle-item-remove><svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="transparent"></rect> <path d="M5 7.5H19L18 21H6L5 7.5Z" stroke="rgb(101, 101, 101)" stroke-linejoin="round"></path> <path d="M15.5 9.5L15 19" stroke="rgb(101, 101, 101)" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 9.5V19" stroke="rgb(101, 101, 101)" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8.5 9.5L9 19" stroke="rgb(101, 101, 101)" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16 5H19C20.1046 5 21 5.89543 21 7V7.5H3V7C3 5.89543 3.89543 5 5 5H8M16 5L15 3H9L8 5M16 5H8" stroke="rgb(101, 101, 101)" stroke-linejoin="round"></path> </g></svg></button>
                    </div>
                </div>
            </div>`;
        });
        this.productList.innerHTML = addedProductsItems;
        this.initRemoveBtnClickEvent();

        this.manageTotals(subtotal,subtotalCMP);
        // let currentDiscountIndexValue = this.currentDiscountIndex(subtotal);
        // let upcomingDiscountIndexValue = this.upcomingDiscountIndex(subtotal);

        // /*
        // [
        //   {
        //     "total": 5000,
        //     "discount": 15,
        //     "code": "FF_DEV_TESTING_PURPOSE_15",
        //     "msg": "Spend Rs. {remaining} &amp; get 15% OFF"
        //   },
        //   {
        //     "total": 7000,
        //     "discount": 25,
        //     "code": "FF_DEV_TESTING_PURPOSE_25",
        //     "msg": "Add Rs. {remaining} more to unlock 25% OFF"
        //   },
        //   {
        //     "total": 10000,
        //     "discount": 30,
        //     "code": "FF_DEV_TESTING_PURPOSE_30",
        //     "msg": "Add Rs. {remaining} more to unlock 30% OFF"
        //   }
        // ]
        // */
        // // console.log("currentDiscountIndexValue",currentDiscountIndexValue,"upcomingDiscountIndex",upcomingDiscountIndexValue,"this.discountJSON",this.discountJSON);
        // let total = subtotal;
        // let preventDiscount = false;

        // const values = Array.from(
        //   document.querySelectorAll('[data-product-list] .bundle-added-item')
        // ).map(el => Number(el.getAttribute('data-category-index')));
        // const uniqueValues = [...new Set(values)];

        // if(document.querySelectorAll('.bundle-step-grid .bundle-step').length != uniqueValues.length){
        //   preventDiscount = true;
        // }

        // // manage discount
        // if(currentDiscountIndexValue == -1 || preventDiscount == true){
        //   this.discountEle.innerHTML = `Rs. 0`;
        //   this.discountEle.dataset.code = '';
        //   this.discountAppliedEle.innerHTML = ``;
        // }else{
        //   let obj = this.discountJSON[currentDiscountIndexValue];
        //   let t = obj.total * 100;
        //   let discountC = subtotal * obj.discount / 100;
        //   console.log("discountC",discountC);
        //   total = subtotal - discountC;
        //   this.discountEle.innerHTML = Shopify.formatMoney(discountC);
        //   this.discountEle.dataset.code = obj.code;
        //   this.discountAppliedEle.innerHTML = `🎁🎉 You got ${obj.discount}% OFF!`;
        // }
        // // manage discount msg
        // if(upcomingDiscountIndexValue == -1 ){
        //   this.discountMsgEle.innerHTML = ``;
        // }else{
        //   let obj = this.discountJSON[upcomingDiscountIndexValue];
        //   let remaining = (obj.total * 100) - total;
        //   this.discountMsgEle.innerHTML = obj.msg.replace('{remaining}',Shopify.formatMoney(remaining,'{{amount_no_decimals}}'));
        // }

        // this.subtotalEle.innerHTML = Shopify.formatMoney(subtotal);
        // this.totalEle.innerHTML = Shopify.formatMoney(total);

    }else{
        // blank summary block
        this.productList.innerHTML = this.emptyHTML;
    }
  }

  manageTotals(subtotal,subtotalCMP){
    console.log("manageTotals>>>>>>",subtotal,subtotalCMP);
    let currentDiscountIndexValue = this.currentDiscountIndex(subtotal);
    let upcomingDiscountIndexValue = this.upcomingDiscountIndex(subtotal);

    /*
    [
      {
        "total": 5000,
        "discount": 15,
        "code": "FF_DEV_TESTING_PURPOSE_15",
        "msg": "Spend Rs. {remaining} &amp; get 15% OFF"
      },
      {
        "total": 7000,
        "discount": 25,
        "code": "FF_DEV_TESTING_PURPOSE_25",
        "msg": "Add Rs. {remaining} more to unlock 25% OFF"
      },
      {
        "total": 10000,
        "discount": 30,
        "code": "FF_DEV_TESTING_PURPOSE_30",
        "msg": "Add Rs. {remaining} more to unlock 30% OFF"
      }
    ]
    */
    // console.log("currentDiscountIndexValue",currentDiscountIndexValue,"upcomingDiscountIndex",upcomingDiscountIndexValue,"this.discountJSON",this.discountJSON);

    let mainDiscount = subtotalCMP - subtotal;
    let mainDiscountPer = 100 - (subtotal*100/subtotalCMP);
    this.discountEleMain.innerHTML = `- ${Shopify.formatMoney(mainDiscount)}`;
    // this.discountEleMain.closest(`.bundle-summary-total-item`).querySelector(`.t-label`).innerHTML = `Bundle Discount 🎁🎉 (${Math.round(mainDiscountPer)}% OFF)`;

    let total = subtotal;
    let preventDiscount = false;

    const values = Array.from(
      document.querySelectorAll('[data-product-list] .bundle-added-item')
    ).map(el => Number(el.getAttribute('data-category-index')));
    const uniqueValues = [...new Set(values)];

    if(document.querySelectorAll('.bundle-step-grid .bundle-step:has(.grid__item)').length != uniqueValues.length){
      preventDiscount = true;
    }
    // console.log("preventDiscount>>>",preventDiscount);

    // manage discount
    let addiDisc = 0;
    let addiDiscPer = ``;
    if(currentDiscountIndexValue == -1 || preventDiscount == true){
      this.discountEle.innerHTML = ``;
      // this.discountEle.innerHTML = ``;
      this.discountEle.dataset.code = '';
    }else{
      let obj = this.discountJSON[currentDiscountIndexValue];
      addiDiscPer = obj.discount;
      let t = obj.total * 100;
      let discountC = subtotal * obj.discount / 100;
      // console.log("discountC",discountC);
      addiDisc = discountC;
      total = subtotal - discountC;
      this.discountEle.innerHTML = `- ${Shopify.formatMoney(discountC)}`;
      this.discountEle.dataset.code = obj.code;
      this.discountAppliedEle.innerHTML = `${this.discountAppliedEle.dataset.label} ${obj.discount}% Off!`;
      this.discountAppliedEle.innerHTML = `${this.discountAppliedEle.dataset.label}`;
    }

    //total savings
    this.savingsEle.innerHTML = `- ` + Shopify.formatMoney(mainDiscount+addiDisc).replace(`Rs.`,"");
    // if(addiDiscPer != ""){
    // this.savingsEle.closest(`.bundle-summary-total-item`).querySelector(`.t-label`).innerHTML = `Total Discount (Discount ${Math.round(mainDiscountPer)}% + Additional ${addiDiscPer}% off)`;
    // }else{
    //   this.savingsEle.closest(`.bundle-summary-total-item`).querySelector(`.t-label`).innerHTML = `Total Discount (Discount ${Math.round(mainDiscountPer)}%)`;
    // }

    // manage discount msg
    // if(upcomingDiscountIndexValue == -1 ){
    //   this.discountMsgEle.innerHTML = ``;
    // }else{
    //   let obj = this.discountJSON[upcomingDiscountIndexValue];
    //   let remaining = (obj.total * 100) - total;
    //   this.discountMsgEle.innerHTML = obj.msg.replace('{remaining}',Shopify.formatMoney(remaining,'{{amount_no_decimals}}'));
    // }

    this.subtotalEleMain.innerHTML = Shopify.formatMoney(subtotalCMP);
    this.subtotalEle.innerHTML = Shopify.formatMoney(subtotal);
    this.totalEle.innerHTML = Shopify.formatMoney(total);
  }

  getSubtotal(){
    let subtotal = 0;
    let subtotalCMP = 0;
    let bundleProds = document.querySelectorAll('[data-product-list] .bundle-added-item');
    bundleProds.forEach(item => {
      let price = parseFloat(item.dataset.price);
      let cmpPrice = parseFloat(item.dataset.cmpPrice);
      let qty = item.querySelector(`quantity-input input`).value;
      // console.log("price",price,"qty",qty);
      subtotal += price*qty;
      subtotalCMP += cmpPrice*qty;
    });
    this.manageTotals(subtotal,subtotalCMP);
  }

  currentDiscountIndex(subtotal) {
    let index = -1;
    for (let i = 0; i < this.discountJSON.length; i++) {
      if (subtotal >= (this.discountJSON[i].total*100)) {
        index = i; // keep updating to highest achieved
      }
    }
    return index;
  }
  upcomingDiscountIndex(subtotal) {
    for (let i = 0; i < this.discountJSON.length; i++) {
      if (subtotal < (this.discountJSON[i].total*100)) {
        return i; // first tier not yet reached
      }
    }
    return -1; // no upcoming (user exceeded all tiers)
  }

  bundleBulkAdd(event){
    console.log("bundleBulkAdd",event);
    let btn = event.target;
    btn.innerHTML = "Adding products to cart...";
    let itemsObj = [];
    let timestamp = Date.now();
    let bLength = this.querySelectorAll('[data-product-list] .bundle-added-item').length;
    this.querySelectorAll('[data-product-list] .bundle-added-item').forEach(element => {
        let item = {};
        item.id = element.dataset.variantId;
        item.quantity = parseInt(element.querySelector(`quantity-input`).input.value);
        item.properties = {
          _timestamp: timestamp,
          _bundle_products: bLength,
          _d_code: this.discountEle.dataset.code ? this.discountEle.dataset.code : null
        }
        itemsObj.push(item);
    });
    console.log("itemsObj",itemsObj);
    // debugger;
    let ADDTOCART_OBJECT = { items : itemsObj}
    fetch(routes.cart_add_url+'.js', {
        method: 'POST',
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(ADDTOCART_OBJECT)
    })
    .then(response => response.json()).then(response => { 
    console.log("response",response);        
    })
    .catch((error) => {
    console.error('Error:', error);
    })
    .finally((e) => {
    // console.log("finally");
    });


    if(this.discountEle.dataset.code != undefined && this.discountEle.dataset.code != ""){
      fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
          "discount": this.discountEle.dataset.code
      }),
      });
    }
  }
  
}

customElements.define('custom-bundles', CustomBundles);


// document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
//   const smartcart = event.detail.smartcart;
//   const item = event.detail.item;

//   console.log("rebuy:smartcart.line-item-removed: smartcart>>>>>>", smartcart, item);
//   if(item.properties && item.properties._bundle_products != undefined){
//     fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//           "discount": ''
//       }),
//     });
//   }
// });